import * as $ from 'jquery';

export default function getElementSize(selector: string | Element) {
    const div = $(selector).trigger('select');
    let width = div.width();
    if (width <= 0) {
        width = 300;
    }
    let height = div.height();
    if (!height || height <= 0) {
        height = 480;
    }
    return {
        width: width,
        height: height
    };
}